<div class="report">

  <div class="topSpacer"></div>
  <div class="spacer"></div>
  <div class="center" style="padding-left: 40px">
    <h1>{{ reportSummary?.report?.name }}</h1>
  </div>
  <div class="center" style="padding-left: 40px">
    <h1 class="green">Rådgivarrapport</h1>
  </div>

  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>

  <div class="center">
    <img src="/assets/smaland_reportpicture.png" width="600" />
  </div>

  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>

  <div class="flex-row">
    <div class="flex-1">
      <div class="reportLogo">
        <img src="/assets/smaland_logo.png" height="100" />
      </div>
    </div>
  </div>

  <div class="pageBreak"></div>

  <div class="topSpacer"></div>
  <div class="flex-row">
    <div class="flax-1 pageTitleContainer">
      <h1 class="pageTitle">Innehållsförteckning</h1>
    </div>
  </div>
  <a href="#sammanfattning"><span class="tocLevel1">Sammanfattning</span></a><br />
  <a href="#swedishwelcome"><span class="tocLevel1">Information om rådgivningen</span></a><br />
  <a href="#gastresan"><span class="tocLevel1">Gästresan</span></a><br />
  @for (aspectGroup of reportSummary?.aspectGroups; track aspectGroup) {
    <ul>
      <li><a href="#aspektgrupp{{aspectGroup.reportAspectGroupId}}"><span class="tocLevel2">{{ aspectGroup.name }}</span></a></li>
    </ul>
  }
  <a href="#standarder"><span class="tocLevel1">Standarder</span></a>
  @for (standardGroup of reportSummary?.standardGroups; track standardGroup) {
    <ul>
      <li><a href="#standardgrupp{{standardGroup.reportStandardGroupId}}"><span class="tocLevel2">{{ standardGroup.name }}</span></a></li>
    </ul>
  }
  <div class="pageBreak"></div>

  <div class="topSpacer"></div>
  <div class="flex-row">
    <div class="flex-1 pageTitleContainer">
      <h1 class="pageTitle">Sammanfattning</h1>
    </div>
  </div>
  <div class="left">{{ $safeNavigationMigration(reportSummary?.report?.visitDate) | dateFormatter:false }}</div>
  <div class="spacer"></div>
  <div [innerHtml]="getHtml($safeNavigationMigration(reportSummary?.report?.summary))"></div>
  <div class="spacer"></div>
  <div class="pageBreak"></div>

  <div class="topSpacer"></div>
  <div class="flex-row">
    <div class="flex-1" class="pageTitleContainer">
      <h1 class="pageTitle">Information om rådgivningen</h1>
    </div>
  </div>
  <div class="left">
    <p><strong>Din rådgivarrapport – för bättre gästupplevelser och en hållbar utveckling</strong></p>
    <p>
      Här får du en sammanställning av genomförd rådgivning med fokus på bättre gästupplevelser och en hållbar utveckling.
      Rapporten bygger på både det oanmälda besöket och det bokade mötet, och fungerar som en handlingsplan att arbeta vidare med.
      Den lyfter fram verksamhetens styrkor och ger konkreta tips och förbättringsförslag inom framkomna utvecklingsområden.
    </p>
    <p>Rapporten består av två delar:</p>
    <ol>
      <li>En objektiv bedömning av gästupplevelsen från det oanmälda besöket.</li>
      <li>En återkoppling av verksamheten bakom kulisserna från det bokade mötet.</li>
    </ol>

    <div class="spacer"></div>
    <div class="flex-row">
      <div class="flex-1"><img src="/assets/globalgoals.png" width="70" /></div>
      <div class="flex-grow80">
        Rådgivningen utgår från hållbarhetsprinciperna. Genom att arbeta strukturerat med rapportens innehåll bidrar din verksamhet – direkt eller indirekt – till samtliga 17 delmål i Agenda 2030.
      </div>
    </div>
  </div>
  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="flex-row" style="background-color: rgba(54,96,40, 0.2); padding: 8px;">
    <div class="flex-1">
      Denna rådgivning har till syfte att utveckla verksamheternas utbud av gästupplevelser och hållbar utveckling. Observera att detta inte innefattar någon kontroll- eller tillsynsfunktion. Det är alltid verksamheten själv som ansvarar för att säkerställa gästernas och medarbetarnas trygghet samt att gällande lagar, regler och branschföreskrifter följs.
    </div>
  </div>
  <div class="pageBreak"></div>

  <div class="topSpacer"></div>
  <div class="flex-row">
    <div class="flex-1 pageTitleContainer">
      <h1 class="pageTitle">Gästresan</h1>
    </div>
  </div>
  <div class="left">
    Denna del av rapporten handlar om gästresan och verksamhetens erbjudande utifrån en bättre gästupplevelse.
    Styrkor och utvecklingsområden hämtade från det oanmälda besöket lyfts fram och verksamhetsanpassade förslag ges för vidareutveckling.
  </div>
  <div class="spacer"></div>
  <div class="left">
    Diagrammet ger en översikt av gästresan och var den egna verksamheten befinner sig i skalan "Åtgärd krävs" till "Enastående".
  </div>

  @if (barChartLabels.length > 0) {
    <div class="chart">
      <canvas baseChart width="625" height="400"
        [datasets]="barChartData"
        [labels]="barChartLabels"
        [options]="barChartOptions"
        [legend]="false"
      [type]="barChartType"></canvas>
    </div>
  }

  <div class="center">
    <span>Totalt i procent {{ reportSummary?.report?.scorePercentage }}%</span>
  </div>
  <div class="spacer"></div>
  <h3>Gränsvärden för den övergripande bedömningen</h3>
  @for (score of reportSummary?.scoreLevelInfo; track score; let idx = $index) {
    <div class="left">
      @if (score.scoreLevel >=0) {
        <span>{{ getThreashold($safeNavigationMigration(reportSummary?.scoreLevelInfo), idx) }}</span>
      }
    </div>
  }

  @for (aspectGroup of reportSummary?.aspectGroups; track aspectGroup) {
    <div>
      <div class="pageBreak"></div>
      <div class="topSpacer"></div>
      <div class="flex-row">
        <div class="flex-1 pageTitleContainer">
          <h3 class="pageTitle" [attr.id]="'aspektgrupp' + aspectGroup.reportAspectGroupId">{{ aspectGroup.name }}</h3>
        </div>
      </div>
      <table class="reportTable">
        <tr>
          <th class="reportHeaderCell">Aspekt</th>
          <th class="reportHeaderCellCenter" colspan="2" [innerHtml]="getYear($safeNavigationMigration(reportSummary?.report?.previousReportVisitDate))"></th>
          <th class="reportHeaderCellCenter" colspan="2" [innerHtml]="getYear($safeNavigationMigration(reportSummary?.report?.visitDate))"></th>
        </tr>
        @for (aspect of aspectGroup?.aspects; track aspect) {
          @if (aspect.scoreLevel >= 0) {
            <tr class="reportRow">
              <td class="reportCell defaultFont">{{ aspect.name }}</td>
              <td class="reportCell defaultFont">@if (aspect.previousScoreLevel >= 0) {
                <span>{{ aspect.previousScoreLevel }}</span>
              }</td>
              <td class="reportCell defaultFont">{{ aspect.previousScoreLevelName }}</td>
              <td class="reportCell defaultFont"><span>{{ aspect.scoreLevel }}</span></td>
              <td class="reportCell defaultFont">{{ aspect.scoreLevelName }}</td>
            </tr>
          }
        }
        <tr class="reportRow">
          <td class="reportCellSymmary" style="text-align: right">Aspektgrupp totalt:</td>
          <td class="reportCellSymmary" colspan="2"></td>
          <td class="reportCellSymmary"><strong>{{ aspectGroup.scorePercentage }}%</strong></td>
          <td class="reportCellSymmary"><strong>{{ aspectGroup.scoreLevelName }}</strong></td>
        </tr>
      </table>
      <div class="spacer"></div>
      <div [innerHtml]="getHtml(aspectGroup.comments)"></div>
      <div class="spacer"></div>
      @if (aspectGroup.proposals && aspectGroup.proposals.length > 0) {
        <div>
          <h4>Förslag</h4>
          @for (proposal of aspectGroup.proposals; track proposal) {
            <ul>
              <li [innerHtml]="getHtml(proposal.details)"></li>
            </ul>
          }
        </div>
      }
      @if (aspectGroup.previousProposals && aspectGroup.previousProposals.length > 0) {
        <div>
          <div class="spacer"></div>
          <h4>Kvarstående förslag från tidigare år</h4>
          @for (proposal of aspectGroup.previousProposals; track proposal) {
            <ul>
              <li>
                @if (proposal.originalDate) {
                  <span>{{ proposal.originalDate | dateFormatter:false }}:&nbsp;</span>
                  }<span [innerHtml]="getHtml(proposal.details)"></span>
                  @if (proposal.comment) {
                    <div><br /><span [innerHtml]="getHtml(proposal.comment)"></span></div>
                  }
                </li>
              </ul>
            }
          </div>
        }
      </div>
    }

    <div class="pageBreak"></div>
    <div class="topSpacer"></div>
    <div class="flex-row">
      <div class="flex-1 pageTitleContainer">
        <h1 class="pageTitle">Standarder</h1>
      </div>
    </div>
    <div class="left">
      Denna del av rapporten handlar om en hållbar verksamhetsstyrning och är uppdelad i ett
      antal standarder som gås igenom under uppföljningsmötet.
    </div>
    <div class="spacer"></div>
    <div class="left bold">Informationen i anslutning till en ej uppfylld standard beskriver först kriterierna som bedöms. Därefter följer ett antal förslag på aktiviteter verksamheten kan genomföra för att nå en uppfylld standard. Dessa förslag består av både standardiserade och verksamhetsanpassade åtgärder.</div>
    <div class="spacer"></div>
    <div class="left">
      Att aktivt jobba med ständiga förbättringar och att sträva efter att driva en hållbar verksamhet är inte bara bra för miljön, det är också bra för verksamhetens hållbarhetsprofil och stärker varumärket gentemot gäster, medarbetare och samarbetspartners.
    </div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="flex-row">
      <div class="flex-grow30">
        Uppfyllda standarder: {{ reportSummary?.report?.standardFulfilledPercentage}}%<br />
        Ej uppfyllda standarder: {{ 100 - reportSummary?.report?.standardFulfilledPercentage}}%
      </div>
      @if (pieChartData?.length > 0) {
        <div class="flex-grow70">
          <div style="display: block; width: 500px; height: 250px;">
            <canvas baseChart
              [options]="pieChartOptions"
              [datasets]="pieChartData"
              [labels]="pieChartLabels"
            [type]="pieChartType"></canvas>
          </div>
        </div>
      }
    </div>
    @for (standardGroup of reportSummary?.standardGroups; track standardGroup) {
      <div>
        <div class="pageBreak"></div>
        <div class="topSpacer"></div>
        <div class="flex-row">
          <div class="flex-1 pageTitleContainer">
            <h3 class="pageTitle" [attr.id]="'standardgrupp' + standardGroup.reportStandardGroupId">{{standardGroup.name}}</h3>
          </div>
        </div>
        <table class="reportTable">
          <tr>
            <th class="reportHeaderCell">Standard</th>
            <th class="reportHeaderCellCenter" [innerHtml]="getYear($safeNavigationMigration(reportSummary?.report?.previousReportVisitDate))"></th>
            <th class="reportHeaderCellCenter" [innerHtml]="getYear($safeNavigationMigration(reportSummary?.report?.visitDate))"></th>
          </tr>
          @for (standard of standardGroup?.reportStandards; track standard) {
            <tr class="reportRow">
              @if (standard.fulfilled != -1) {
                <td class="reportCell defaultFont">{{ standard.name }}</td>
                <td [attr.class]="standard.previousFulfilled == 1 ? 'reportCellGreen' : (standard.previousFulfilled == 0 ? 'reportCellRed' : 'reportCellWhite') + ' reportCell'">{{ getStandardLabel(standard.previousFulfilled) }}</td>
                <td [attr.class]="standard.fulfilled == 1 ? 'reportCellGreen' : 'reportCellRed' + ' reportCell'">{{ getStandardLabel(standard.fulfilled) }}</td>
              }
            </tr>
          }
          <tr class="reportRow">
            <td class="reportCellSummary" style="text-align: right">Uppfylld totalt:</td>
            <td class="reportCellSummary" [innerHtml]="getPreviousStandardGroupFulfillmentPercentage(reportSummary, $safeNavigationMigration(standardGroup?.standardGroupId))"></td>
            <td class="reportCellSummary"><strong>{{ standardGroup.fulfilledPercentage }}%</strong></td>
          </tr>
        </table>
        @if (standardGroup?.comment) {
          <div class="spacer"></div>
          <div class="left" style="font-weight: bold">Övergripande kommentarer</div>
          <div class="left" [innerHtml]="getHtml(standardGroup.comment)"></div>
        }
        @for (standard of standardGroup?.reportStandards; track standard) {
          @if (standard.fulfilled == 0 && standard.suggestions) {
            <div class="suggestionBox">
              <div class="spacer"></div>
              <div class="flex-row">
                <div class="flex-1 suggestionTitle">{{standard.name}}</div>
                <div class="flex-1"></div>
              </div>
              <div fxLayout="column" class="suggestionBody">
                <div class="left"><span style="font-weight: bold">Standardkriterier:</span></div>
                <div class="flex-1" [innerHtml]="getHtml(standard.description)"></div>
                <div class="spacer"></div>
                <div class="left"><span style="font-weight: bold">Förslag:</span></div>
                <div class="flex-1" [innerHtml]="getHtml(standard.suggestions)"></div>
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
